import React from "react";
import { SectionsUIProvider } from "./SectionsUIContext";
import { SectionsCard } from "./SectionsCard";

export function SectionsPage({ history }) {
  const sectionsUIEvents = {
    openNewSectionPage: () => {
      history.push("/subeler/ekle");
    },
    openEditSectionPage: (id) => {
      history.push(`/subeler/duzenle/${id}`);
    },
  };
  
  return (
    <SectionsUIProvider sectionsUIEvents={sectionsUIEvents}>
      <SectionsCard />
    </SectionsUIProvider>
 );
}